import {UseInfiniteQueryResult, useInfiniteQuery} from '@tanstack/react-query';

import api from 'app/modules/Remote/api';

import {NotesQueryParams, OrgNoteStatsApiResponse} from '../types';

const PER_PAGE = 100;

export function useOrgNoteStats(
  orgId: string,
  params: NotesQueryParams = {}
): UseInfiniteQueryResult<OrgNoteStatsApiResponse[], Error> {
  // Stable query key including all relevant API parameters
  const queryKey = ['dashboardNotes', orgId, params.startDate, params.endDate, params.noteType];

  return useInfiniteQuery({
    queryKey,
    queryFn: async ({pageParam = 1}) => {
      const response = await api.dashboardStats(orgId).getNotes({
        ...params,
        page: pageParam,
        perPage: PER_PAGE,
      });
      return response.get('data').toJS() as OrgNoteStatsApiResponse[];
    },
    getNextPageParam: (lastPage, allPages) => {
      // If the last page has less items than page size, we've reached the end
      const hasMore = lastPage.length === PER_PAGE;
      return hasMore ? allPages.length + 1 : undefined;
    },
    initialPageParam: 1,
    // Keep the same caching behavior as useOrgFeatureMetadata
    staleTime: Infinity,
    select: (data) => {
      return data.pages.flat();
    },
  });
}
